// const ednpointWeb = 'https://collaudo.smartphonecash.it';
const ednpointWeb = 'https://www.smartphonecash.it';
export default ednpointWeb;
